/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

//子账户联系人详情
export function detail(param) {
    return request(`${config.server}/api/v1/dms/employee//getAccount/id=${param}`);
}



//渠道联系人
export function list(param) {
  /**
   *  {
        accountStatus (integer, optional),
        birthdayDate (string, optional): 生日 ,
        channelId (integer, optional): 渠道ID ,
        contactInfoList (Array[DmsContactInfo], optional): 联系人联系方式集合 ,
        createdBy (integer, optional): 创建人ID ,
        createdDate (string, optional): 创建日期 ,
        dept (string, optional): 所属部门 ,
        id (integer, optional): 主键ID ,
        ids (Array[integer], optional),
        itemselector (Array[integer], optional),
        lastUpdatedBy (integer, optional): 最后更新人ID ,
        lastUpdatedDate (string, optional): 最后更新时间 ,
        name (string, optional): 姓名 ,
        p (integer, optional): 页码 ,
        post (string, optional): 所属岗位 ,
        removeFlag (integer, optional): 软删除标识 ,
        reqType (integer, optional): 访问类型 ,
        s (integer, optional): 每页条数 ,
        sex (integer, optional): 性别 ,
        userId (integer, optional): 用户ID
        }
   */
  return request(`${config.server}/api/v1/dms/channelContact/list`, {
    method: 'post',
    body: param,
  });
}
//新增渠道联系人
export function add(param) {
  /**
   *  {
        content (string, optional): 联系方式内容 ,
        createdBy (integer, optional),
        createdDate (string, optional),
        id (integer, optional),
        ids (Array[integer], optional),
        itemselector (Array[integer], optional),
        lastUpdatedBy (integer, optional),
        lastUpdatedDate (string, optional),
        p (integer, optional): 页码 ,
        relatedTableId (integer, optional): 关联表id，根据related_table_type字段的不同，关联不同的表的主键id ,
        relatedTableType (integer, optional): 关联表类型：1-渠道联系人；2-门店联系人；3-员工 ,
        removeFlag (integer, optional),
        reqType (integer, optional): 访问类型 ,
        s (integer, optional): 每页条数 ,
        type (integer, optional): 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
       }
   */
  return request(`${config.server}/api/v1/dms/channelContact/save`, {
    method: 'post',
    body: param,
  });
}
export function update(param) {
  /**
   *  {
        content (string, optional): 联系方式内容 ,
        createdBy (integer, optional),
        createdDate (string, optional),
        id (integer, optional),
        ids (Array[integer], optional),
        itemselector (Array[integer], optional),
        lastUpdatedBy (integer, optional),
        lastUpdatedDate (string, optional),
        p (integer, optional): 页码 ,
        relatedTableId (integer, optional): 关联表id，根据related_table_type字段的不同，关联不同的表的主键id ,
        relatedTableType (integer, optional): 关联表类型：1-渠道联系人；2-门店联系人；3-员工 ,
        removeFlag (integer, optional),
        reqType (integer, optional): 访问类型 ,
        s (integer, optional): 每页条数 ,
        type (integer, optional): 联系方式类型：1-手机；2-座机；3-Email；4-QQ；5-微信；6-钉钉
       }
   */
  return request(`${config.server}/api/v1/dms/channelContact/update`, {
    method: 'post',
    body: param,
  });
}
//开通账号
export function createAccount(param) {
  return request(`${config.server}/api/v1/dms/channelContact/createAccount?id=${param.id}`);
}
//渠道联系人启用和禁用账号
export function updateAccountStatus(param) {
  return request(`${config.server}/api/v1/dms/channelContact/updateAccountStatus`, {
    method: 'post',
    body: param,
  });
}



// WEBPACK FOOTER //
// ./src/service/channel/linkman.js